import axios from 'axios';
import {handleSessionExpired} from 'utils/handleSessionExpiry';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

// If any request through this instance comes back unauthorized, the session
// has expired — force the user out so they log in again instead of getting
// stuck on silently failing requests.
api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      handleSessionExpired();
    }
    throw error;
  },
);
